<template>
    <div>
        <Header/>
        <Nav :list="headerList"/>
        <div ref="content">
            <SingleBanner/>
            <div class="page-content">
                <div class="page-content-left">
                    <div class="page-content-left-title">{{obj.title}}</div>
                    <div class="page-content-left-time">{{obj.create_time}}</div>
                    <div class="page-content-left-content" v-html="obj.content"></div>
                </div>
                <div class="page-content-right">
                    <RightTab :list="arr"/>
                </div>
            </div>
        </div>
        <Footer/>
    </div>
</template>
<script>
import RightTab from './components/rightTab.vue';
import { mapState } from 'vuex'
export default {
    computed: mapState([
    ]),
    components:{
       RightTab,
    },
    data() {
        return {
            headerList:[
                {name:'首页', href:'/'},
                {name:'IFM会员活动', href:'/ifmMember'},
                {name:'', href:'/ifmDesc'},
            ],
            arr:[
            ],
            obj:{}
        }
    },
    mounted(){
        this.getDetail();
        this.getList();
    },
    methods: {
        async getList(){
            const res = await this.$http.get('/api/index/getActivityList',{page:1,limit:5});
            this.arr = res.list;
        },
        getDetail(){
            this.$http.get('/api/index/getActivityDetail',{id:this.$route.query.id}).then(res => {
                this.obj = res;
                this.headerList[2].name = res.title;
            })
        }
    },
}
</script>
<style lang="scss" scoped>
.news{
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    .single{
        width: 580px;
    }
}
</style>
